import { getLocalStorageValue } from "./localStorage"
import { retrieveDataFromApi } from "./api"
import { isFunnelFoxPipeline, getFunnelFoxOrderData } from "./funnelFox"

const LOCAL_STORAGE_KEY = "data"

// Start: helper functions
function getValuesFromUrl(parameters, urlParametersArray) {
  for (let parameterName of urlParametersArray) {
    if (parameterName.includes("=")) {
      const [key, value] = parameterName.split("=", 2)
      parameters[key] = value
    } else {
      parameters[parameterName] = ""
    }
  }

  return parameters
}

function getUrlParameters() {
  const currentUrl = window.location.href
  const decodedUrl = decodeURIComponent(currentUrl)
  const hashFragments = decodedUrl.split("#") || []
  const queryString = decodedUrl.split("?")[1]?.split("#")[0] || "" // Needed due FF query string
  const queryParams = queryString ? queryString.split("&") : []

  return { hashFragments, queryParams }
}

// End: helper functions

// Start: main functions
async function getCppv3OrderData(params, dataStore) {
  const token = params["token"] || params["stored-token"]
  const localStorageToken = getLocalStorageValue(LOCAL_STORAGE_KEY, "token")

  if (token && localStorageToken !== token) {
    dataStore.values = { token }

    await retrieveDataFromApi(dataStore)
  }
}

export async function getOrderData(dataStore) {
  try {
    if (!dataStore) {
      throw new Error("Data store is missing")
    }

    const { hashFragments, queryParams } = getUrlParameters()

    let params = {}
    params = getValuesFromUrl(params, hashFragments)
    params = getValuesFromUrl(params, queryParams)

    if (isFunnelFoxPipeline()) {
      await getFunnelFoxOrderData(params, dataStore)

      return
    }

    await getCppv3OrderData(params, dataStore)
  } catch (error) {
    console.error("[getOrderData]: ", error)
  }
}
// End: main functions
